export const settingInputType = {
    input: 'input',
    select: 'select',
    multiselect: 'multiselect'
};
